'use strict';

const braintreeVenmoSDK = require('./braintreeVenmoSDK');
const braintreeGeneral = require('../../braintreeGeneral');
const venmoProcessing = require('../components/venmoProcessing');

// Braintree Venmo Model
class BraintreeVenmoModel {
    constructor(){
        this.braintreeClientInstancePromise = null;
    }

    /**
     * Init Braintree Venmo model
     * @param {Promise} braintreeClientInstancePromise Braintree client instance promise
     */
    init(braintreeClientInstancePromise) {
        braintreeVenmoSDK.init(braintreeClientInstancePromise);

        this.braintreeClientInstancePromise = braintreeClientInstancePromise;
    }

    /**
     * Returns fraud data from dataCollector payload
     * @returns {Object} Payload with fraud data
     */
    collectFraudData() {
        let response;

        try {
            response = braintreeGeneral.collectFraudData(this.braintreeClientInstancePromise);
        } catch (error) {
            response = Promise.resolve({
                customMessage: 'Fraud Data collection isn`t enabled via Custom Site Preference'
            });
        }

        return response;
    }

    /**
     * Checks whether browser supports Venmo
     * @returns {Promise} with isBrowserSupported value
     */
    isBrowserSupported() {
        return braintreeVenmoSDK.isBrowserSupported();
    }

    /**
     * Creates Venmo instance
     * @param {boolean} isCustomerRegistered - If customer is authenticated or not
     * @returns {Promise} - Promise that resolves into a Venmo instance
     */
    createVenmoInstance(isCustomerRegistered) {
        return braintreeVenmoSDK.createVenmo(isCustomerRegistered);
    }

    /**
     * Inits Venmo button
     * @param {Object} venmoInstance Venmo instance
     * @param {string} pageFlow Current page flow
     * @returns {Promise | undefined} Promise resolved with a tokenized payload or undefined
     */
    async tokenize() {
        try {
            const payload = await braintreeVenmoSDK.tokenize(this.venmoInstance);
            const result = await venmoProcessing.processVenmo(payload, this.configs.pageFlow);

            this.loader.hide();

            return result;
        } catch (error) {
            const VenmoAlertHandlerModel = require('../alertHandler/venmoAlertHandlerModel');
            const alertHandler = new VenmoAlertHandlerModel();

            if ([window.braintreeConstants.PAGE_FLOW_PDP, window.braintreeConstants.PAGE_FLOW_PVP].includes(this.configs.pageFlow)) {
                const payPalProductModelHelper = require('../../paypal/helpers/payPalProductPageModelHelper');

                payPalProductModelHelper.removeProductFromCart();
            }

            alertHandler.showError(error.message);

            this.loader.hide();

            return undefined;
        }
    }
}

module.exports = BraintreeVenmoModel;
